import React from "react";
import XLSX from "xlsx";
import { saveAs } from "file-saver";
import { isUndefined } from "util";
import { ExportCsv, ExportPdf } from "@material-table/exporters";

import locale from "antd/es/date-picker/locale/en_US";

export const dateFormat = "DD-MM-YYYY";
export const dateTimeFormat = "DD-MM-YYYY HH:mm";

export function datePickerProps(time = false) {
  return {
    locale: {
      ...locale,
      lang: {
        ...locale.lang,
        placeholder: "Choisir une date",
        today: "Aujourd'hui",
        now: "Maintenant",
        dateSelect: "Date",
        timeSelect: "Heure",
        rangePlaceholder: ["Date de début", "Date de fin"],
      },
    },
    format: time ? dateTimeFormat : dateFormat,
  };
}

export function selectProps() {
  return {
    notFoundContent: "Aucun résultat...",
    showSearch: true,
    allowClear: true,
    filterOption: (input, option) => {
      let str = option.props.children;
      if (typeof str !== "string") str = option.props.children.props.value;
      if (typeof str !== "string") str = "";
      return str.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
  };
}

export function textareaProps() {
  return {
    autoSize: { minRows: 4, maxRows: 20 },
  };
}

export function materialTableProps(exportFilename = "export", columns = {}, tableRef, pageSize) {
  return {
    localization: {
      body: {
        emptyDataSourceMessage: "Aucune donnée",
        editRow: {
          deleteText: "Voulez-vous vraiment supprimer cette entrée?",
        },
        filterRow: {
          filterTooltip: "Filtre",
        },
      },
      pagination: {
        labelDisplayedRows: "{from}-{to} de {count}",
        labelRowsSelect: "ligne(s)",
        firstTooltip: "Première page",
        previousTooltip: "Page précédente",
        nextTooltip: "Page suivante",
        lastTooltip: "Dernière page",
      },
      toolbar: {
        exportTitle: "Exporter",
        exportName: "Exporter pour Excel",
        addRemoveColumns: "Colonne(s) à afficher",
        showColumnsTitle: "Colonne(s) à afficher",
        searchTooltip: "Chercher",
        searchPlaceholder: "Chercher",
      },
      header: {
        actions: "Actions",
      },
    },
    options: {
      exportButton: true,

      emptyRowsWhenPaging: false,
      toolbar: true,
      sorting: true,
      draggable: false,
      filtering: true,
      debounceInterval: 700,
      exportMenu: [
        {
          label: "Export PDF",
          exportFunc: (cols, datas) => ExportPdf(cols, datas, "CLB"),
          exportAllData: true,
        },
        {
          label: "Export Excel",
          exportFunc: (cols, data) => {
            const dataRows = data.map(({ tableData, ...row }) => Object.values(row));
            const currentCols = cols.filter((col) => col.hidden === false);

            let tempData = [];
            let exportedHeaders = [];

            currentCols.forEach((col) => {
              exportedHeaders.push(col.title);
            });

            // eslint-disable-next-line no-unused-expressions
            tableRef?.current?.dataManager?.data?.forEach((row) => {
              let tempRow = {};
              currentCols.forEach((c, idx) => {
                // Converting bool to oui/non
                var val = "";
                if (c.exportTransformer) val = c.exportTransformer(c, row);
                else if (c.render) val = c.render(row);
                else if (c.lookup) val = c.lookup[row[c.field]];
                else if (c.type === "boolean")
                  val = row[c.field] === true || row[c.field] === 1 ? "Oui" : "Non";
                else {
                  val = row[c.field];
                }

                try {
                  tempRow[c.title] = val ? val.trim() : val;
                } catch {
                  tempRow[c.title] = String(val);
                }
                tempRow[exportedHeaders[idx]] = val;
              });
              tempData.push(tempRow);
            });

            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.json_to_sheet(tempData, {
              header: exportedHeaders,
            });
            XLSX.utils.book_append_sheet(wb, ws, "");

            const wbout = XLSX.write(wb, {
              bookType: "xlsx",
              bookSST: true,
              type: "binary",
            });

            const buf = new ArrayBuffer(wbout.length);

            const view = new Uint8Array(buf);

            for (let i = 0; i !== wbout.length; ++i) view[i] = wbout.charCodeAt(i) & 0xff;
            saveAs(
              new Blob([buf], {
                type: "application/octet-stream",
              }),
              `${exportFilename}.xlsx`,
            );
          },
          exportAllData: true,
        },
      ],
      exportAllData: true,
      showTitle: false,
      search: false,
      columnsButton: true,
      pageSize: pageSize,
      actionsColumnIndex: -1,
      pageSizeOptions: [5, 10, 15, 20, 25, 50, 100, 150, 200, { value: 100000, label: "All" }],
      headerStyle: {},
      rowStyle: {},
    },
  };
}
